import { Provider } from '@angular/core';

import { ContentUploadStore } from '../api-content/content-store';
import { ContentUploadStoreService } from './content-upload-store.service';

export const CONTENT_PROVIDERS: Provider[] = [{ provide: ContentUploadStore, useClass: ContentUploadStoreService }];
